<template>
  <div class="div-conteudo">
    <transition name="modal" v-if="carregando">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
            <label>Aguarde. Carregando.</label>
          </div>
        </div>
      </div>
    </transition>
    <div class="fora" v-else>
      <div class="index centro">
        <div class="topo-index">
          <h1>Fale conosco</h1>
          <router-link :to="{
            name: 'OcorrenciasNew',
          }">
            <span>+</span> Novo
          </router-link>
        </div>
        <div v-if="temPermissao.admin || temPermissao.gpd" class="caixa-pesquisa">
          <h2 @click="tooglePesquisa()">
            Pesquisa
            <span>
              <template v-if="!exibirPesquisa">&#9650;</template>
              <template v-else>&#9660;</template>
            </span>
          </h2>
            <form @submit.prevent v-show="!exibirPesquisa">
              <div>
                <div class = "row3-data">
                  <div class="item" style="flex: 1.3">
                    <label> Título: </label>
                    <input type="text" placeholder="Digite o título da Ocorrência" v-model="filtro.titulo" />
                  </div>
                  <div class="item" style="flex: 0.5"> 
                    <label>Tipo:</label>
                    <select id="tipo" v-model="filtro.tipo">
                      <option v-for="opcao in tipoOptions" :key="opcao.value" :value="opcao.value">
                        {{ opcao.label }}
                      </option>
                    </select>
                  </div>
                  <div class="item" style="flex: 0.5"> 
                    <label>Status:</label>
                    <select id="status" v-model="filtro.status">
                      <option v-for="opcao in statusOptions" :key="opcao.value" :value="opcao.value">
                        {{ opcao.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="botoes-pesquisa">
                <div class="bt-pesquisa">
                  <button title="Pesquisar" type="button" @click="fazerBusca">
                    <img src="../../assets/imagens/pesquisa.png" class="pesquisa" alt=" " />
                    Pesquisar
                  </button>
                </div>
                <div class="bt-limpar">
                  <button title="Limpar" @click="limparFiltro()">
                    <img src="../../assets/imagens/icon-eraser.png" class="limpar" alt=" " />
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </form>
        </div>
        <div class="n-div">
          <div class="nresultados" v-show="!carregando">
            <label>Total de Resultados: {{ this.totalResultadosTexto }}</label>
          </div>
          <div class="npagina" v-show="!carregando">
            <label>Resultados por Página </label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div v-if="temPermissao.admin || temPermissao.gpd" class="container-tabela">
          <TabelaResultadosOcorrencias
            :ocorrencias="ocorrencias"
            :ocorrencia="ocorrencia"
            :usuario_logado="usuario_logado"
            v-if="!carregando && !erro && !erroFiltro"
            @excluir-linha="excluirLinha"
          />
        </div>
        <div v-else class="container-tabela">
          <TabelaResultadosOcorrenciasUsuario
            :ocorrencias="ocorrencias"
            :ocorrencia="ocorrencia"
            v-if="!carregando && !erro && !erroFiltro"
            @excluir-linha="excluirLinha">
          </TabelaResultadosOcorrenciasUsuario>
        </div>
        <paginate v-if="!carregandoFiltro && !carregando" v-model="pagina" :page-count="pageCount"
              :click-handler="mudouPagina" :prev-text="'Anterior'" :next-text="'Próxima'" :container-class="'className'"
              active-class="active-page"></paginate>
        <BannerContato />
      </div>
    </div>
  </div>
</template>

<script>
  import Paginate from "vuejs-paginate";
  import tryParseInt from "../../helpers/tryParseInt";
  import metaDados from "../../helpers/metaDados";
  import TabelaResultadosOcorrencias from "../../components/ocorrencias/TabelaResultadosOcorrencias.vue";
  import TabelaResultadosOcorrenciasUsuario from "../../components/ocorrencias/TabelaResultadosOcorrenciasUsuario.vue";
  import OcorrenciaApi from "../../services/OcorrenciaApi";
  import Auth from '../../services/Auth';
  import BannerContato from "../../components/ocorrencias/BannerContato.vue";

  export default {
    name: "Ocorrencia",
    metaInfo() {
      return {
        title: "Ocorrencias",
        titleTemplate: "%s - Casa Civil do Estado de Goiás",
        meta: [
          {
            vmid: "description",
            name: "description",
            property: "description",
            content:
              "Página de acesso e pesquisa de todos os ocorrencias realizados.",
          },
          {
            vmid: "og:description",
            property: "og:description",
            content:
              "Página de acesso e pesquisa de todos os ocorrencias realizados.",
          },
          {
            vmid: "og:title",
            property: "og:title",
            content: "Ocorrencias - Casa Civil do Estado de Goiás",
          },
          ...metaDados(this.$route),
        ],
      };
    },
    data() {
      return {
        auth: null,
        usuario_logado: null,
        temPermissao: null,
        ocorrencias: [],
        ocorrencia: null,
        carregando: true,
        erro: false,
        totalResultados: null,
        totalResultadosTexto: null,
        pagina: 1,
        qtd_por_pagina: 10,
        filtro: {
            titulo: '',
            tipo: '',
            status: '',
        },
        tipoOptions: [
          { value: '', label: 'Todos' },
          { value: 'melhoria', label: 'Sugestão'},
          { value: 'erro', label: 'Reporte de erro'},
          { value: 'duvida', label: 'Dúvida'},
          { value: 'elogio', label: 'Elogio'},
          { value: 'reclamacao', label: 'Reclamação'},
        ],
        statusOptions: [
          { value: '', label: 'Todos' },
          { value: 'aberto', label: 'Aberto' },
          { value: 'em_andamento', label: 'Em andamento' },
          { value: 'finalizado', label: 'Finalizado' },
        ],
        exibirPesquisa: true,
        carregandoFiltro: false,
        erroFiltro: false,
        msgErros: {
          ocorrencia: '',
          default: ''
        },
      };
    },
    components: {
      TabelaResultadosOcorrencias,
      TabelaResultadosOcorrenciasUsuario,
      Paginate,
      BannerContato,
    },
    created() {
      this.ocorrenciaApi = new OcorrenciaApi();
      this.auth = new Auth();
      this.usuario_logado = this.auth.usuario;
      this.temPermissao = this.auth.temPermissao;

      this.carregarQtdPorPagina();
      this.carregarValoresFiltro();
      this.carregarOcorrencia();
    },
    watch: {
      '$route.query': {
        handler() {
          this.carregarValoresFiltro();
          this.carregarOcorrencia();
        },
        immediate: true
      }
    },
    methods: {
      tooglePesquisa: function () {
        this.exibirPesquisa = !this.exibirPesquisa;
      },
      async excluirLinha(ocorrenciaId) {
        try {
          this.carregando = true;
          this.erro = false;

          if (this.ocorrenciaApi.cancelTokens.destroyOcorrencia) {
            this.ocorrenciaApi.cancelTokens.destroyOcorrencia.cancel();
          }

          await this.ocorrenciaApi.destroyOcorrencia(ocorrenciaId);

          // Atualiza a lista imediatamente
          this.ocorrencias = this.ocorrencias.filter(o => o.id !== ocorrenciaId);

          // Você pode evitar chamar this.carregarOcorrencia se quiser mais controle
        } catch (err) {
          if (this.ocorrenciaApi.isCancel(err)) return;
          this.carregando = false;
          this.erro = true;
          this.msgErros.ocorrencia = "Não foi possível excluir a ocorrência.";
        }
      },
      fazerBusca() {
        console.log('Filtro no momento da busca:', this.filtro);
        this.$router.replace({
          name: "Ocorrencia",
          query: {
            titulo: this.filtro.titulo,
            tipo: this.filtro.tipo,
            status: this.filtro.status,
            pagina: 1,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        }).catch((err) => {
          if (err.name !== 'NavigationDuplicated') {
            throw err; // só ignora duplicados
          }
        });
      },
      mudouQtdPagina: function (event) {
        const novaQtdPagina = parseInt(event.target.value);
        if (novaQtdPagina < this.qtd_por_pagina) {
          this.qtd_por_pagina = novaQtdPagina;
          this.mudouPagina(this.pagina);
        } else {
          let novaPagina = Math.ceil(
            (this.qtd_por_pagina * this.pagina) / novaQtdPagina
          );

          this.qtd_por_pagina = novaQtdPagina;
          this.mudouPagina(novaPagina);
        }
      },
      getParam: function (name) {
        if (this.$route && this.$route.query) {
          return this.$route.query[name];
        }
        return null;
      },
      mudouPagina: function (page) {
        this.pagina = page;

        const filtro = {
          titulo: this.getParam("titulo"),
          tipo: this.getParam("tipo"),
          status: this.getParam("status"),
        };

        this.$router.push({
          name: "Ocorrencia",
          query: {
            ...filtro,
            pagina: this.pagina,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        });
      },
      carregarValoresFiltro: async function () {
        try {
          this.filtro.titulo = this.getParam("titulo") || '';
          this.filtro.tipo = this.getParam("tipo") || '';
          this.filtro.status = this.getParam("status") || '';
          this.erroFiltro = false;
        } catch (err) {
          this.carregandoFiltro = false;
          this.erroFiltro = true;
        }
      },
      carregarOcorrencia: async function () {
        if (!this.ocorrenciaApi) return;

        try {
          this.carregando = true;
          this.erro = false;

          this.qtd_por_pagina = this.getParam("qtd_por_pagina") || this.qtd_por_pagina;

          this.armazenarQtdPorPagina();

          const pagina = this.getParam("pagina") || 1;
          this.pagina = parseInt(pagina);

          const titulo = this.getParam("titulo") || "";
          const tipo = this.getParam("tipo") || "";
          const status = this.getParam("status") || "";

          if (this.ocorrenciaApi.cancelTokens.getOcorrencias) {
            this.ocorrenciaApi.cancelTokens.getOcorrencias.cancel();
          }

          let data = await this.ocorrenciaApi.getOcorrencias({
            titulo,
            tipo,
            status,
            qtd_por_pagina: this.qtd_por_pagina,
            page: this.pagina,
          });

          this.ocorrencias = [...data.resultados];
          this.totalResultados = data.total_resultados;

          if (data.total_resultados >= 1000) {
            this.totalResultadosTexto = (data.total_resultados / 1000).toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          } else {
            this.totalResultadosTexto = data.total_resultados;
          }

          this.carregando = false;
        } catch (err) {
          if (this.ocorrenciaApi?.isCancel && this.ocorrenciaApi.isCancel(err)) return;
          this.carregando = false;
          this.erro = true;
        }
      },
      limparFiltro() {
        this.$router.push({
          name: "Ocorrencia",
          query: {
            titulo: '',
            tipo: '',
            status: '',
            pagina: 1,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        });
      },
      armazenarQtdPorPagina() {
        localStorage.setItem(
          "qtd_por_pagina_ocorrencia",
          this.qtd_por_pagina
        );
      },
      carregarQtdPorPagina() {
        const qtd = localStorage.getItem("qtd_por_pagina_ocorrencia");
        if (qtd) {
          this.qtd_por_pagina = tryParseInt(qtd);
        }
      },
    },
    computed: {
      pageCount: function () {
        if (
          this.totalResultados != undefined &&
          this.totalResultados != null &&
          this.qtd_por_pagina != null &&
          this.qtd_por_pagina != undefined &&
          this.totalResultados > 0 &&
          this.qtd_por_pagina > 0
        ) {
          return Math.ceil(this.totalResultados / this.qtd_por_pagina);
        }
        return 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
.modal-container.nova-modal {
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #fff;
  padding: 1.5rem;
  max-width: 500px;
  margin: auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  text-align: center;

  .titulo-modal {
    color: #f7a600;
    font-size: 1.4rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .dados-modal {
    text-align: left;
    padding: 1rem;
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-bottom: 1rem;

    p {
      margin: 0.5rem 0;
      font-size: 0.95rem;

      strong {
        color: #333;
      }
    }
  }

  .botoes-modal {
    display: flex;
    justify-content: space-around;
    margin-top: 1rem;

    .botao-sim {
      background-color: #007a00;
      color: #fff;
      border: none;
      padding: 0.5rem 1.2rem;
      font-weight: bold;
      border-radius: 5px;
      cursor: pointer;

      &:hover {
        background-color: #005f00;
      }
    }

    .botao-nao {
      background-color: #c10000;
      color: #fff;
      border: none;
      padding: 0.5rem 1.2rem;
      font-weight: bold;
      border-radius: 5px;
      cursor: pointer;

      &:hover {
        background-color: #a00000;
      }
    }
  }
}
</style>